<template>
  <main class="overview">

    <div :class="cardsClass"
         v-if="data">
      <app-overview-card data-key="regiteredUsers"
                         :data-heading="$t('message.overview.message.registeredUsers')"
                         data-icon="account-group"
                         :data-index="0" />

      <app-overview-card data-key="releasedUsers"
                         :data-heading="$t('message.overview.message.connectedUsers')"
                         data-icon="account-network"
                         v-if="isEstablishment"
                         :data-index="1" />

      <app-overview-card data-key="activeCampaigns"
                         :data-heading="$t('message.overview.message.activeCampaigns')"
                         data-icon="bullhorn"
                         :data-index="2" />

      <app-overview-card data-key="activeLocals"
                         :data-heading="localsHeading"
                         data-icon="router-wireless"
                         :data-index="3" />

      <app-overview-card data-key="engamentPercentage"
                         :data-heading="$t('message.statistics.message.engagement')"
                         data-icon="cursor-default-click-outline"
                         data-append="%"
                         :data-index="4" />
    </div>

    <div class="main">
      <app-chart v-if="visualizarEstatistica"
                 data-name="access"
                 data-type="line"
                 :data-heading="accessHeading"
                 maintainAspectRatio />

      <app-overview-comments v-if="visualizarComentario" />
    </div>

  </main>
</template>

<script>
    import AppOverviewCard from './components/OverviewCard'
    import AppOverviewComments from './components/OverviewComments'
    import AppChart from '@components/chart/Chart'
    //import moment from 'moment'

    export default {
        components: {
            AppOverviewCard,
            AppOverviewComments,
            AppChart,
        },

        computed: {
            locale() {
                return this.$store.state.users.locale
            },

            data() {
                return this.$store.state.statistics.overview
            },

            isEstablishment() {
                return this.$store.state.users.user.tipo === 'ESTABELECIMENTO';
            },

            accessHeading() {
                return this.isEstablishment ? this.$t('message.overview.message.accessesLast30Days') : this.$t('message.overview.message.insertsLast30Days')
            },

            localsHeading() {
                return this.isEstablishment ? this.$t('message.overview.message.activeSpots') : this.$t('message.overview.message.linkedSpots')
            },

            user() {
                return this.$store.state.users.user
            },
            cardsClass(){
                if (this.isEstablishment){
                    return 'cards-establishments';
                }
                return 'cards-advertisiers';
            },
            permissions() {
              return this.$store.state.users.user.permissions;
            },
            visualizarComentario() {
              return this.permissions &&  this.permissions.find(x => x === "READ_COMMENTS") ? true : false;
            },
            visualizarEstatistica() {
              return this.permissions && this.permissions.find(x => x === "READ_STATISTICS") ? true : false;
            },
        },

        watch: {
            locale() {
                this.$loader.statistics.overview()
            }
        },

        mounted() {
            // this.$store.commit('STATISTICS_SET_FILTER', {
            //     key: 'date',
            //     value: {
            //         min: this.$date.parse(moment().subtract(1, 'months')),
            //         max: this.$date.parse(moment()),
            //     }
            // })
            this.$loader.statistics.overview()
        },

        // beforeMount() {
        //   location.assign(`${location.protocol}//${location.hostname}${process.env.NODE_ENV === "development" ? `:${Number(location.port) + 1}` : ''}/new/estabelecimento/visao-geral`);
        // }
    }
</script>

<style lang="scss" scoped>
.overview {
  .cards-establishments {
    height: calc(30% - 60px);
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-column-gap: 40px;
  }

  .cards-advertisiers {
    height: calc(30% - 60px);
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 40px;
  }

  .main {
    margin: 34px 0 20px 0;
    height: calc(70% - 20px);
    display: grid;
    grid-template-columns: minmax(510px, auto) minmax(390px, 520px);
    grid-template-rows: auto;
    grid-template-areas: "impressions comments";
    grid-column-gap: 40px;
  }
}
</style>
